import React from 'react';
import { Card, CardContent } from './ui/card';
import { Globe, Zap, DollarSign, Headphones } from 'lucide-react';

const WhyChooseUs = ({ language, translations }) => {
  const features = [
    {
      icon: Globe,
      title: translations.store,
      description: translations.storedesc,
      color: '#3dd3ee'
    },
    {
      icon: Zap,
      title: translations.fast,
      description: translations.fastdesc,
      color: '#fad24b'
    },
    {
      icon: DollarSign,
      title: translations.pricing,
      description: translations.pricingdesc,
      color: '#ff8c19'
    },
    {
      icon: Headphones,
      title: translations.support,
      description: translations.supportdesc,
      color: '#8b1538'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-white to-[#f7f5f2]">
      <div className="container mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-[#1e1919] mb-16">
          {translations.title}
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card 
                key={index}
                className="border-2 hover:shadow-xl transition-all transform hover:scale-105 hover:border-[#8b1538]/30"
                style={{ borderColor: `${feature.color}30` }}
              >
                <CardContent className="p-8 text-center">
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                    style={{ backgroundColor: `${feature.color}20` }}
                  >
                    <Icon className="w-8 h-8" style={{ color: feature.color }} />
                  </div>
                  <h3 className="text-xl font-bold text-[#1e1919] mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-[#736c64]">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
